module.exports = __webpack_public_path__ + "img/document-download-outline.611d4b6a.svg";